import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UiScrollModule } from "ngx-ui-scroll";
import { GadgetModule } from "../gadget/gadget.module";
import { GadgetUserListComponent } from "./gadget-user-list.component";
import { RoleHelpDialogModule } from "../dialogs/role-help-dialog/role-help-dialog-component.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MaterialModule,
        SharedModule,
        UiScrollModule,
        RoleHelpDialogModule
    ],
    declarations: [GadgetUserListComponent],
    exports: [GadgetUserListComponent]

})
export class GadgetUserListModule { }